// @flow weak

import _ from 'lodash/fp';
import uuid from 'uuid';
import {ADD as NOTIFICATION} from './notification';
import {GET, POST, PUT, DELETE} from '../helpers/request';
import {FILE_UPLOAD, ABORT_UPLOAD} from '../middleware/fileUploader';
import {sortByName} from './apartmentConfigView';

export const GET_REQUEST = '@apartmentView/GET_REQUEST';
export const GET_SUCCESS = '@apartmentView/GET_SUCCESS';
export const GET_FAILURE = '@apartmentView/GET_FAILURE';

export const CREATE_REQUEST = '@apartmentView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@apartmentView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@apartmentView/CREATE_FAILURE';

export const UPDATE_REQUEST = '@apartmentView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@apartmentView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@apartmentView/UPDATE_FAILURE';

export const PROJECT_GET_REQUEST = '@apartmentView/PROJECT_GET_REQUEST';
export const PROJECT_GET_SUCCESS = '@apartmentView/PROJECT_GET_SUCCESS';
export const PROJECT_GET_FAILURE = '@apartmentView/PROJECT_GET_FAILURE';

export const CONFIGURATIONS_REQUEST = '@apartmentView/CONFIGURATIONS_REQUEST';
export const CONFIGURATIONS_SUCCESS = '@apartmentView/CONFIGURATIONS_SUCCESS';
export const CONFIGURATIONS_FAILURE = '@apartmentView/CONFIGURATIONS_FAILURE';

export const DEVIATIONS_REQUEST = '@apartmentView/DEVIATIONS_REQUEST';
export const DEVIATIONS_SUCCESS = '@apartmentView/DEVIATIONS_SUCCESS';
export const DEVIATIONS_FAILURE = '@apartmentView/DEVIATIONS_FAILURE';

export const ADD_DEVIATION = '@apartmentView/ADD_DEVIATION';
export const UPDATE_DEVIATION = '@apartmentView/UPDATE_DEVIATION';
export const REMOVE_DEVIATION = '@apartmentView/REMOVE_DEVIATION';
export const OPEN_DEVIATION = '@apartmentView/OPEN_DEVIATION';
export const CLOSE_DEVIATION = '@apartmentView/CLOSE_DEVIATION';

export const ADD_FILE = '@apartmentView/ADD_FILE';
export const REMOVE_FILE = '@apartmentView/REMOVE_FILE';
export const ABORT_FILE_UPLOAD = '@apartmentView/ABORT_FILE_UPLOAD';
export const FILE_UPLOADED = '@apartmentView/FILE_UPLOADED';

export const TOGGLE_COPY_DIALOG = '@apartmentView/TOGGLE_COPY_DIALOG';
export const RESET = '@apartmentView/RESET';
export const CLEAR = '@apartmentView/CLEAR';

export const FILE_UPDATE_REQUEST = '@apartmentView/FILE_UPDATE_REQUEST';
export const FILE_UPDATE_SUCCESS = '@apartmentView/FILE_UPDATE_SUCCESS';
export const FILE_UPDATE_FAILURE = '@apartmentView/FILE_UPDATE_FAILURE';
export const TOGGLE_RENAME_DIALOG = '@apartmentView/TOGGLE_RENAME_DIALOG';

export const DELETE_FILE_REQUEST = '@apartmentView/DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = '@apartmentView/DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = '@apartmentView/DELETE_FILE_FAILURE';

const deleteFileRequest = () => ({
  type: DELETE_FILE_REQUEST,
});

const deleteFileSuccess = (apartment: any) => ({
  type: DELETE_FILE_SUCCESS,
  apartment,
});

const deleteFileFailure = (error: any) => ({
  type: DELETE_FILE_FAILURE,
  error,
});

export const deleteFile = (apartmentId: number, file: any) => async dispatch => {
  dispatch(deleteFileRequest());
  try {
    await DELETE({endpoint: `/files/${file.id}`}, dispatch);
    const apartment = await GET({endpoint: `/apartments/${apartmentId}`}, dispatch);
    dispatch(deleteFileSuccess(apartment));
  } catch (err) {
    dispatch(deleteFileFailure(err));
  }
};

const updateFileRequest = () => ({
  type: FILE_UPDATE_REQUEST,
});

const updateFileSuccess = (name: 'contract' | 'floorPlan' | 'kitchenPlan', metadata) => ({
  type: FILE_UPDATE_SUCCESS,
  name,
  metadata,
});

const updateFileFailure = error => ({
  type: FILE_UPDATE_FAILURE,
  error,
});

export const toggleRenameDialog = (show: false | 'contract' | 'floorPlan' | 'kitchenPlan') => ({
  type: TOGGLE_RENAME_DIALOG,
  show,
});

const apartmentRequest = () => ({
  type: GET_REQUEST,
});

const apartmentSuccess = (apartment, project, apartmentConfigurations) => ({
  type: GET_SUCCESS,
  apartment,
  project,
});

const apartmentFailure = error => ({
  type: GET_FAILURE,
  error,
});

const apartmentCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const apartmentCreateSuccess = apartment => ({
  type: CREATE_SUCCESS,
  apartment,
  [NOTIFICATION]: {
    message: 'Lägenhet skapad',
  },
});

const apartmentCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

const apartmentUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const apartmentUpdateSuccess = apartment => ({
  type: UPDATE_SUCCESS,
  apartment,
  [NOTIFICATION]: {
    message: 'Lägenhet uppdaterad',
  },
});

const apartmentUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const projectRequest = () => ({
  type: PROJECT_GET_REQUEST,
});

const projectSuccess = project => ({
  type: PROJECT_GET_SUCCESS,
  project,
});

const projectFailure = error => ({
  type: PROJECT_GET_FAILURE,
  error,
});

const deviationsRequest = () => ({
  type: DEVIATIONS_REQUEST,
});

const deviationsSuccess = deviations => ({
  type: DEVIATIONS_SUCCESS,
  deviations,
});

const deviationsFailure = error => ({
  type: DEVIATIONS_FAILURE,
  error,
});

const apartmentConfigurationsRequest = () => ({
  type: CONFIGURATIONS_REQUEST,
});

const apartmentConfigurationsSuccess = apartmentConfigurations => ({
  type: CONFIGURATIONS_SUCCESS,
  apartmentConfigurations,
});

const apartmentConfigurationsFailure = error => ({
  type: CONFIGURATIONS_FAILURE,
  error,
});

const fileUploaded = name => (tempId, metadata) => ({
  type: FILE_UPLOADED,
  name,
  tempId,
  metadata,
});

export const toggleCopyDialog = show => ({
  type: TOGGLE_COPY_DIALOG,
  show,
});

export const addApartmentDeviation = deviation => ({
  type: ADD_DEVIATION,
  deviation,
});

export const updateApartmentDeviation = (deviationId, data) => ({
  type: UPDATE_DEVIATION,
  deviationId,
  data,
});

export const removeApartmentDeviation = deviationId => ({
  type: REMOVE_DEVIATION,
  deviationId,
});

export const openApartmentDeviation = deviation => ({
  type: OPEN_DEVIATION,
  deviation,
});

export const closeApartmentDeviation = () => ({
  type: CLOSE_DEVIATION,
});

export const addFile = (name, file) => ({
  type: ADD_FILE,
  tempId: uuid.v4(),
  name,
  [FILE_UPLOAD]: {
    file,
    success: fileUploaded(name),
  },
});

export const removeFile = name => ({
  type: REMOVE_FILE,
  name,
});

export const clear = () => ({
  type: CLEAR,
});

export const abortUpload = tempId => ({
  type: ABORT_FILE_UPLOAD,
  tempId,
  [ABORT_UPLOAD]: true,
});

export const abortAllUploads = uploads => dispatch => {
  _.forEach(u => dispatch(abortUpload(u)), uploads);
};

export const fetchApartmentConfigurations = (projectId, apartmentConfigId = null) => async dispatch => {
  dispatch(apartmentConfigurationsRequest());
  try {
    let apartmentConfigurations = await GET({endpoint: `/projects/${projectId}/apartmentconfigs`}, dispatch);
    if (!!apartmentConfigId && !_.some(x => x.id === apartmentConfigId, apartmentConfigurations)) {
      const apartmentConfig = await GET({endpoint: `/apartmentconfigs/${apartmentConfigId}`}, dispatch);
      if (!!apartmentConfig) {
        apartmentConfigurations = [
          ...apartmentConfigurations,
          apartmentConfig,
        ];
      }
    }
    dispatch(apartmentConfigurationsSuccess(sortByName(apartmentConfigurations)));
  } catch (err) {
    dispatch(apartmentConfigurationsFailure(err));
  }
};

export const fetchApartment = id => async dispatch => {
  dispatch(apartmentRequest());
  try {
    const apartment = await GET({endpoint: `/apartments/${id}`}, dispatch);
    const project = await GET({endpoint: `/projects/${apartment.projectId}`}, dispatch);
    dispatch(fetchApartmentConfigurations(project.id, apartment.apartmentConfigId));
    dispatch(apartmentSuccess(apartment, project));
  } catch (err) {
    dispatch(apartmentFailure(err));
  }
};

export const createApartment = (projectId, body) => async dispatch => {
  dispatch(apartmentCreateRequest());
  try {
    const apartment = await POST({
      endpoint: `/projects/${projectId}/apartments`,
      body,
    }, dispatch);
    dispatch(apartmentCreateSuccess(apartment));
  } catch (err) {
    dispatch(apartmentCreateFailure(err));
  }
};

export const updateApartment = (id, body) => async dispatch => {
  dispatch(apartmentUpdateRequest());
  try {
    const apartment = await PUT({
      endpoint: `/apartments/${id}`,
      body,
    }, dispatch);
    dispatch(apartmentUpdateSuccess(apartment));
  } catch (err) {
    dispatch(apartmentUpdateFailure(err));
  }
};

export const fetchProject = id => async dispatch => {
  dispatch(projectRequest());
  try {
    const project = await GET({endpoint: `/projects/${id}`}, dispatch);
    dispatch(projectSuccess(project));
  } catch (err) {
    dispatch(projectFailure(err));
  }
};

export const fetchDeviations = () => async dispatch => {
  dispatch(deviationsRequest());
  try {
    const deviations = await GET({endpoint: '/deviations'}, dispatch);
    dispatch(deviationsSuccess(deviations));
  } catch (err) {
    dispatch(deviationsFailure(err));
  }
};

export const reset = () => ({
  type: RESET,
});

export const updateFile = (id, name: 'contract' | 'floorPlan' | 'kitchenPlan', body) => async dispatch => {
  dispatch(updateFileRequest());
  try {
    const file = await PUT({
      endpoint: `/files/${id}`,
      body,
    }, dispatch);
    dispatch(updateFileSuccess(name, file));
  } catch (err) {
    dispatch(updateFileFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/apartmentView.js